/**
 * Attempts to convert a given value to a Number and returns zero if that attempt produced `NaN`.
 *
 * @example
 * import alwaysNumber from '@carvana/futilities/alwaysNumber';
 * alwaysNumber('300.17')
 * // () => 300.17
 * alwaysNumber('abc')
 * // () => 0
 * alwaysNumber()
 * // () => 0
 */
function alwaysNumber(value: number | string) {
  return Number.isNaN(+value) ? 0 : +value;
}

export default alwaysNumber;
